import React, { memo, useMemo } from 'react'

import { Button, Icon, Image2, Text } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, shape, func, bool } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Tabs({ tabs }) {
  const t = useTranslation()
  const { image, text } = tabs

  const buttons = useMemo(() => [
    {
      key: image.id,
      label: t('shared.actionSelector.tabs.image'),
      icon: Image2,
      onClick: image.onClick,
      isActive: image.isActive,
    },
    {
      key: text.id,
      label: t('shared.actionSelector.tabs.text'),
      icon: Text,
      onClick: text.onClick,
      isActive: text.isActive,
    },
  ], [t, tabs])

  return (
    <div className="action-selector__tabs">
      {buttons.map(({ key, label, icon, onClick, disabled, isActive }) => (
        <Button
          key={key}
          type="secondary"
          variant="with-icon"
          size="tiny"
          customClass="action-selector__tabs-button"
          expand
          onClick={onClick}
          isActive={isActive}
          disabled={disabled}
        >
          <Icon svgComponent={icon} color="darker" size={iconSize} notSpaced />
          {label}
        </Button>
      ))}
    </div>
  )
}

Tabs.propTypes = {
  tabs: shape({
    image: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
    }).isRequired,
    text: shape({
      id: string.isRequired,
      onClick: func.isRequired,
      isActive: bool.isRequired,
    }).isRequired,
  }).isRequired,
}

export default memo(Tabs)
